module.exports = function() {
  return new Worker(__webpack_public_path__ + "fc28e22ece7f36fe076f.worker.js");
};